"use strict";

(function ($) {
  "use strict";

  rivets.binders.shindo_paging = function (el, value) {
    var pagingHtml = "";

    if (value > 1) {
      pagingHtml = '<li><a class="previous" href="#" aria-label="Previous" onclick="previousPage()"><span aria-hidden="true">&laquo;</span></a></li>';
    }

    for (var i = 1; i <= value; i++) {
      pagingHtml += '<li><a class="page_number" href="#" onclick="changePage(' + i + ')">' + i + '</a></li>';
    }

    if (value > 1) {
      pagingHtml += '<li><a class="next" href="#" aria-label="Next" onclick="nextPage()"><span aria-hidden="true">&raquo;</span></a></li>';
    }

    el.innerHTML = pagingHtml;
  };

  rivets.binders.shindo_chip = function (el, value) {
    var chipsHtml = ""; //Value should be an array

    if (value && value.length > 0) {
      for (var i = 0; i < value.length; i++) {
        chipsHtml += "<div class='chip'>" + value[i].text + " </div>";
      }
    } else {
      chipsHtml = "<div class='no-chips'>Empty</div>";
    }

    el.innerHTML = chipsHtml;
  };

  rivets.binders.shindo_checkbox = {
    bind: function bind(el) {
      $('#' + el.id + ' input[type="checkbox"]').on('change', this.publish);
    },
    unbind: function unbind(el) {
      $('#' + el.id + ' input[type="checkbox"]').off('change', this.publish);
    },
    routine: function routine(el, val) {
      // val should be an array
      if (val) {
        var checkboxes = $('#' + el.id + ' input[type="checkbox"]');

        for (var i = 0; i < checkboxes.length; i++) {
          var chk = checkboxes[i];
          $(chk).prop('checked', false);

          for (var j = 0; j < val.length; j++) {
            if (chk.value.toLowerCase() == val[j].value.split(':')[0].toLowerCase()) {
              chk.checked = true;
              $(chk).prop('checked', true);
            }
          }
        }
      }
    },
    getValue: function getValue(el) {
      //Should return an array
      var checkboxes = $('#' + el.id + ' input[type="checkbox"]');
      var valuesArray = [];

      for (var i = 0; i < checkboxes.length; i++) {
        var chk = checkboxes[i];

        if (chk.checked) {
          valuesArray.push({
            value: chk.value,
            text: $(chk).prop("labels")[0].textContent
          });
        }
      }

      return valuesArray;
    }
  };
  rivets.binders.shindo_multiselect = {
    bind: function bind(el) {
      el.addEventListener('change', this.publish);
    },
    unbind: function unbind(el) {
      el.removeEventListener('change', this.publish);
    },
    routine: function routine(el, val) {
      // val should be an array
      if (val) {
        var options = $(el).children('option');

        for (var i = 0; i < options.length; i++) {
          var option = options[i];

          for (var j = 0; j < val.length; j++) {
            if (option.value.toLowerCase().indexOf(val[j].split(':')[0].toLowerCase()) != -1) {
              option.selected = true;
            }
          }
        }
      }
    },
    getValue: function getValue(el) {
      //Should return an array
      var options = $(el).children('option');
      var valuesArray = [];

      for (var i = 0; i < options.length; i++) {
        var option = options[i];

        if (option.selected) {
          valuesArray.push(option.value);
        }
      }

      return valuesArray;
    }
  };
  rivets.binders.shindo_textbox = {
    bind: function bind(el) {
      el.addEventListener('keyup', this.publish);
    },
    unbind: function unbind(el) {
      el.removeEventListener('keyup', this.publish);
    },
    routine: function routine(el, val) {
      el.value = val.trim();
    },
    getValue: function getValue(el) {
      if (el) {
        return el.value.trim();
      }

      return "";
    }
  };

  rivets.binders.style_background_image = function (el, value) {
    el.style.setProperty('background-image', "url(" + value + ")");
  };
})(jQuery);